import React from 'react'
import PropTypes from 'prop-types'

const accountAdministrationSVG = ({ color, width, height }) => (
    <svg viewBox="0 0 24 24" width={width} height={height}>
        <g>
            <path
                d=" M 21 15 L 7 15 L 7 17 L 21 17 L 21 15 Z  M 21 11 L 7 11 L 7 13 L 21 13 L 21 11 Z  M 21 7 L 7 7 L 7 9 L 21 9 L 21 7 Z  M 5 7 L 3 7 L 3 9 L 5 9 L 5 7 Z  M 5 17 L 5 15 L 3 15 L 3 17 L 5 17 Z  M 5 11 L 3 11 L 3 13 L 5 13 L 5 11 Z "
                fill={color}/>
        </g>
    </svg>
)

accountAdministrationSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

accountAdministrationSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default (accountAdministrationSVG)
